import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { getUserWallet, loadUser, loadUserReferralIdentifier, modifyUser, loadUserStoreCreditEvents, loadUserAddressBook, modifyUserAddressBook, removeFromUserAddressBook } from '../redux/actions';
/**
 * The `useUser` hook returns the current user and functions for loading data
 * about the user. At the moment, the only user information Chord supports is
 * the user's referral identifier and personalized referral url.
 *
 * @example
 *
 * ```javascript
 * import { useUser } from '@chordcommerce/react-autonomy'
 *
 * const AccountPage = () => {
 *   const { user, loadUser } = useUser()
 *
 *   return <h1>Hello {user.name}</h1>
 * }
 * ```
 *
 * @category Hook
 */
export function useUser() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user;
  }, shallowEqual);
  var actionDispatches = useMemo(function () {
    return bindActionCreators({
      getUserWallet: getUserWallet,
      loadUser: loadUser,
      loadUserReferralIdentifier: loadUserReferralIdentifier,
      modifyUser: modifyUser,
      loadUserStoreCreditEvents: loadUserStoreCreditEvents,
      loadUserAddressBook: loadUserAddressBook,
      modifyUserAddressBook: modifyUserAddressBook,
      removeFromUserAddressBook: removeFromUserAddressBook
    }, dispatch);
  }, [dispatch]);
  return _objectSpread({
    user: user
  }, actionDispatches);
}